import { IInboxOrder } from "../models/messagesInbox/IInboxConversation";

/**
 * Public tracking pages by courier, for when the order only has a tracking number. Proovia
 * isn't here: it has no public link by number that we know of, so its number is copy-only.
 */
const COURIER_TRACKING: { match: RegExp; url: (n: string) => string }[] = [
  { match: /\bdpd\b/i, url: (n) => `https://track.dpd.co.uk/parcels/${n}` },
  { match: /parcelforce/i, url: (n) => `https://www.parcelforce.com/track-trace?trackNumber=${n}` },
  { match: /royal\s*mail/i, url: (n) => `https://www.royalmail.com/track-your-item#/tracking-results/${n}` },
  { match: /\bevri\b|hermes/i, url: (n) => `https://www.evri.com/track/parcel/${n}` },
  { match: /\bups\b/i, url: (n) => `https://www.ups.com/track?tracknum=${n}` },
  { match: /\bdhl\b/i, url: (n) => `https://www.dhl.com/gb-en/home/tracking/tracking-parcel.html?submit=1&tracking-id=${n}` },
  { match: /fedex/i, url: (n) => `https://www.fedex.com/fedextrack/?trknbr=${n}` },
];

/** The link to track this order: the courier's own link if we have it, else built from the number. */
export function trackingLink(o: Pick<IInboxOrder, "trackingNumber" | "trackingUrl" | "courier">) {
  if (o.trackingUrl) return o.trackingUrl;
  if (!o.trackingNumber || !o.courier) return undefined;
  const courier = COURIER_TRACKING.find((c) => c.match.test(o.courier as string));
  return courier?.url(encodeURIComponent(o.trackingNumber.trim()));
}
